import {BookingStep} from "@page-containers/booking/utils/bookingStep";
import {CustomCategory, EventCategory, EventType} from "src/utils/analytics/constants";
import {getEventQueuer} from "src/utils/analytics/eventQueue";
import {getFlowId} from "src/utils/getFlowId";

import {buildEmailRedirectData} from "./utils/buildEmailEventData";

const postEvent = getEventQueuer({
  category: EventCategory.Custom,
  extraData: {
    category: CustomCategory.AppointmentScheduling,
  },
});

export const postEmailEvent = ({viewId, value}: {viewId: string; value: string}) => {
  postEvent({
    typeId: EventType.EmailTyped,
    extraData: {
      viewId,
      flowId: getFlowId() || null,
      value,
    },
  });
};

export const postEmailErrorEvent = ({
  viewId,
  errorText,
  emailText,
}: {
  viewId: string;
  errorText: string;
  emailText: string;
}) => {
  postEvent({
    typeId: EventType.TypedEmailError,
    extraData: {
      viewId,
      flowId: getFlowId() || null,
      errorText,
      emailText,
    },
  });
};

export const postViewEvent = ({
  viewId,
  apptReasonId,
  locationId,
  slotId,
  milesAway,
  timeToAppt,
  specialtyId,
}: {
  viewId: string;
  apptReasonId: string;
  locationId: string;
  slotId?: string;
  milesAway?: number;
  timeToAppt?: number;
  specialtyId: string;
}) => {
  postEvent({
    typeId: EventType.AccountStepViewed,
    extraData: {
      viewId,
      flowId: getFlowId() || null,
      bookingStep: BookingStep.ACCOUNT_SELECTION,
      apptDetails: {
        specialtyId,
        apptReasonId,
        locationId,
        slotId,
        milesAway,
        timeToAppt,
      },
    },
  });
};

export const postOnNextEvent = ({
  email,
  typeId,
  viewId,
  nextButtonText,
}: {
  email: string;
  typeId: EventType;
  viewId: string;
  nextButtonText: string;
}) => {
  const eventData = buildEmailRedirectData({
    typeId,
    email,
    viewId,
    flowId: getFlowId() || null,
    nextButtonText,
  });
  postEvent(eventData);
};
